import { Component, TemplateRef, ContentChild } from '@angular/core';
import { LanguageService } from 'src/app/shared/services/language.service';
import { TenantConfigService } from 'src/app/shared/services/tenant-config.service';

@Component({
  selector: 'app-auth-container',
  templateUrl: './auth-container.component.html',
  styleUrls: ['./auth-container.component.scss'],
})
export class AuthContainerComponent {
  tenantId = '';
  @ContentChild('content', { read: TemplateRef, static: false })
  content!: TemplateRef<any>;
  constructor(
    public tenantConfigService: TenantConfigService,
    public languageService: LanguageService,
  ) {
    this.tenantId = this.tenantConfigService.tenant.tenantId;
  }
  onLanguageChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.languageService.switchLang(target.value);
  }
}
